<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else>
            <div class="top-right-button-container">
                <b-button-group class="mb-2">
                    <b-dropdown size="sm" variant="outline-primary" right :text="'Actions'">
                        <b-dropdown-item v-if="checkValidStatusChange" @click="clientStatus" size="sm" variant="outline-primary">
                            Change Status
                        </b-dropdown-item>

                        <b-dropdown-item @click="addFamily" size="sm" variant="outline-primary">
                            Add Family Member
                        </b-dropdown-item>

                        <template v-if="client.data.attributes.valid_referral">
                            <b-dropdown-divider/>

                            <b-dropdown-item @click="reReferral" size="sm" variant="outline-primary">
                                Re-referral
                            </b-dropdown-item>
                        </template>

<!--                        <b-dropdown-divider/>-->

<!--                        <b-dropdown-item size="sm" variant="outline-primary">-->
<!--                            Admission-->
<!--                        </b-dropdown-item>-->

<!--                        <b-dropdown-item size="sm" variant="outline-primary">-->
<!--                            Discharge-->
<!--                        </b-dropdown-item>-->

<!--                        <b-dropdown-item size="sm" variant="outline-primary">-->
<!--                            Transfer-->
<!--                        </b-dropdown-item>-->
                    </b-dropdown>

                    <b-button @click="clientComment" size="sm" variant="outline-primary">
                        Add Comment
                    </b-button>

                    <b-dropdown size="sm" variant="primary" right text="More">
                        <b-dropdown-item @click="editClient(client.client_id)">Edit</b-dropdown-item>
                        <b-dropdown-item v-if="!client.data.attributes.previous_admission" @click="deleteClient(client)">Delete</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>

            <div class="d-flex flex-row">
                <span class="iconsminds-family-sign mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="client.data.attributes.name"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <b-tabs nav-class="separator-tabs ml-0 mb-4" content-class="tab-content" :no-fade="true">
                <b-tab title="SUMMARY" @click="getSummary" :active="$route.name === 'client.show'">
                    <b-row>
                        <b-colxx xxs="12" lg="4">
                            <b-card no-body>
                                <b-card-body>
                                    <div class="mt-md-5">
                                        <span class="card-subtitle text-one">Summary of</span><br>

                                        <h4 class="bold">{{ client.data.attributes.name }}</h4>

                                        <b-badge pill class="position-absolute badge-top-left"
                                                 :variant="clientStatusColor(client.data.attributes.status)">
                                            {{ client.data.attributes.status }}
                                        </b-badge>

                                        <b-badge variant="secondary" pill class="position-absolute badge-top-left-2">
                                            {{ client.data.attributes.facility }}
                                        </b-badge>
                                    </div>
                                </b-card-body>

                                <div class="position-relative">
                                    <div class="position-absolute card-top-buttons">
                                        <b-button variant="outline-white" class="icon-button">
                                            <i class="simple-icon-pencil"/>
                                        </b-button>
                                    </div>

                                    <single-lightbox :thumb="client.data.attributes.image" :large="client.data.attributes.image"
                                                     class-name="card-img-top"/>
                                </div>

                                <b-card-body>
                                    <h4 class="mb-4">Details</h4>

                                    <p>
                                        <ListForSummary :icon="'iconsminds-woman-man'" :title="'Gender'"
                                                        :border-bottom="true"
                                                        :content="client.data.attributes.gender"/>
                                        <ListForSummary :icon="'iconsminds-calendar-4'"
                                                        :title="'DOB'" :border-bottom="true"
                                                        :content="client.data.attributes.dob"/>
                                        <ListForSummary :icon="'iconsminds-finger-print'"
                                                        :title="'SSN'" :border-bottom="true"
                                                        :content="client.data.attributes.ssn"/>
                                        <ListForSummary :icon="'iconsminds-pulse'"
                                                        :title="'Medicaid'" :border-bottom="true"
                                                        :content="client.data.attributes.medicaid"/>
                                        <ListForSummary :icon="'iconsminds-mail-with-at-sign'"
                                                        :title="'Email'" :border-bottom="true"
                                                        :content="client.data.attributes.email"/>
                                        <ListForSummary :icon="'iconsminds-smartphone-4'"
                                                        :title="'Phone'"
                                                        :content="client.data.attributes.phone"/>
                                    </p>

                                    <p class="text-muted text-small mb-2">Notes</p>

                                    <p>{{client.data.attributes.notes}}</p>
                                </b-card-body>
                            </b-card>
                        </b-colxx>

                        <b-colxx xxs="12" lg="8">
                            <b-row class="m-0 mb-4 sep-border-bottom">
                                <b-colxx xxs="12" lg="3" class="half-sep-border-right">
                                    <h6 class="mb-n2">Admission<br>
                                        <small class="text-muted">Oft-times</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ client.data.attributes.admission_oft_time }}
                                    </span>
                                </b-colxx>


                                <b-colxx xxs="12" lg="3" class="half-sep-border-right">
                                    <h6 class="mb-n2">Staying For<br>
                                        <small class="text-muted">Currently</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ client.data.attributes.staying_for }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="3" class="half-sep-border-right">
                                    <h6 class="mb-n2">Adult<br>
                                        <small class="text-muted">Family members</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ client.data.attributes.adult_count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="12" lg="3">
                                    <h6 class="mb-n2">Children<br>
                                        <small class="text-muted">Family members</small>
                                    </h6>

                                    <span class="text-muted" style="font-size: 30px">
                                        {{ client.data.attributes.child_count }}
                                    </span>
                                </b-colxx>
                            </b-row>

                            <b-card class="mb-4">
                                <div class="d-flex flex-row">
                                    <i class="iconsminds-conference text-large mb-2 mr-3 menu-icon-style"/>

                                    <div class="my-auto">
                                        <div class="d-inline-block mb-2">
                                            <h5>FAMILY MEMBERS <small class="text-muted">Living with the client</small></h5>
                                        </div>
                                    </div>
                                </div>
                                <vue-perfect-scrollbar v-if="family.length > 0" class="scroll comments-list"
                                                       :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                    <b-row class="mt-1">
                                        <b-colxx xxs="12" class="mb-3" v-for="(member,index) in family"
                                                 :key="index">
                                            <family-list-item :key="index" :data="member"
                                                             @delete="deleteFamily"/>
                                        </b-colxx>
                                    </b-row>
                                </vue-perfect-scrollbar>

                                <div v-else>
                                    <p>No family member added.</p>
                                </div>
                            </b-card>

                            <b-card class="mb-4" no-body>
                                <b-tabs card fade>
                                    <b-tab title="Comments" active>
                                        <vue-perfect-scrollbar v-if="comments.length > 0" class="scroll comments-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <CommentsList v-for="(comment, index) in comments" :data="comment"
                                                          :key="index" @edit="editComment"
                                                          @delete="deleteComment(comment)"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No comments found.</p>
                                        </div>
                                    </b-tab>

                                    <b-tab title="Histories">
                                        <vue-perfect-scrollbar v-if="histories.length > 0" class="scroll histories-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <HistoriesList :data="histories"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No histories found.</p>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </b-colxx>
                    </b-row>
                </b-tab>
            </b-tabs>

            <ClientFormModal :edit="true"
                               @updated="getClient(client.client_id)"/>

            <ClientOtherModal :client="client" :edit="comment_edit" :mode="modalMode" @close="resetOtherModal"
                                @updated="getClient(client.client_id)"/>

            <ClientRereferralModal v-if="referralClicked" :client="client" @closed="referralClicked = false"
                                @updated="getClient(client.client_id)"/>

            <ClientFamilyModal :client="client" :mode="familyMode" :member="member"
                                @updated="getClient(client.client_id)"/>

            <ClientDeleteModal :mode="delete_mode" :comment="selected_comment" :client="client"
                                 @deleted-client="$router.push('/hms/clients/list')"
                                 @deleted-comment="getClient(client.client_id)"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SingleLightbox from "../../../../components/Pages/SingleLightbox";
    import ListForSummary from "../../../../components/Listing/ListForSummary";
    import CommentsList from "../../../../components/Listing/CommentsList";
    import HistoriesList from "../../../../components/Listing/HistoriesList";
    import ClientFormModal from "./modals/ClientFormModal";
    import ClientOtherModal from "./modals/ClientOtherModal";
    import ClientFamilyModal from "./modals/ClientFamilyModal";
    import ClientDeleteModal from "./modals/ClientDeleteModal";
    import FamilyListItem from "../../../../components/Listing/FamilyListItem";
    import ClientRereferralModal from "./modals/ClientRereferralModal";

    export default {
        name: "ClientSummary",

        components: {
            ClientRereferralModal,
            FamilyListItem,
            ClientFormModal,
            ClientOtherModal,
            ClientFamilyModal,
            ClientDeleteModal,
            SingleLightbox,
            ListForSummary,
            CommentsList,
            HistoriesList,
        },

        data() {
            return {
                loading: true,
                modalMode: '',
                delete_mode: null,
                selected_comment: null,
                comment_edit: false,
                familyMode: '',
                member: '',
                referralClicked: false,
            }
        },

        computed: {
            ...mapGetters({
                client: 'getClient',
                family: 'getClientFamily',
                comments: 'getClientComments',
                histories: 'getClientHistories',
            }),

            checkValidStatusChange() {
                return this.client.data.attributes.status.toLowerCase() !== 'discharged' ||
                    this.client.data.attributes.status.toLowerCase() !== 'no-show';
            },

            // clientImage() {
            //     if (this.client.data.attributes.image !== 'Not Assigned') {
            //         return '/storage/images/clients/' + this.client.data.attributes.image;
            //     }
            //
            //     if ((this.client.data.attributes.gender).toLowerCase() === 'male') {
            //         return '/default/gender_male.png';
            //     } else if ((this.client.data.attributes.gender).toLowerCase() === 'female') {
            //         return '/default/gender_female.png';
            //     } else {
            //         return '/default/gender_unknown.png';
            //     }
            // },
        },

        mounted() {
            this.getClient(this.$route.params.client_id);
        },

        methods: {
            async getClient(client_id) {
                await this.$store.dispatch('fetchClient', client_id)
                    .catch(error => {
                        this.$router.push('/error');
                    });

                await this.$store.dispatch('fetchClientFamily', client_id);

                await this.$store.dispatch('fetchClientComments', client_id);

                await this.$store.dispatch('fetchClientHistories', client_id);

                return this.loading = false;
            },

            clientStatus() {
                this.modalMode = 'status';
                this.$bvModal.show('client_other');
            },

            clientComment() {
                this.modalMode = 'comment';
                this.$bvModal.show('client_other');
            },

            editClient(client_id) {
                this.$store.dispatch('fetchEditClient', client_id)
                    .finally(response => {
                        this.$bvModal.show('client_form');
                    });
            },

            reReferral() {
                this.referralClicked = true;

                setTimeout(() => {
                    this.$bvModal.show('client_rereferral');
                }, 1);
            },

            deleteClient() {
                this.delete_mode = 'client';

                setTimeout(() => {
                    this.$bvModal.show('client_delete');
                }, 1);
            },


            clientStatusColor: status => {
                if (status.toLowerCase() === 'referral') return 'warning'
                else if (status.toLowerCase() === 'admitted') return 'success'
                else if (status.toLowerCase() === 'transferred') return 'info'
                else if (status.toLowerCase() === 'discharged') return 'danger'
                else if (status.toLowerCase() === 'duplicate') return 'dark'
                else return 'light'
            },

            editComment(comment_id) {
                this.comment_edit = true;

                this.$store.dispatch('fetchEditClientComment', comment_id)
                    .finally(response => {
                        this.$bvModal.show('client_other');
                    });
            },

            deleteComment(comment) {
                this.selected_comment = comment;
                this.delete_mode = 'comment';

                setTimeout(() => {
                    this.$bvModal.show('client_delete');
                }, 1);
            },

            addFamily() {
                this.familyMode = 'add';

                setTimeout(() => {
                    this.$bvModal.show('client_family');
                }, 1);
            },

            deleteFamily(family) {
                this.familyMode = 'delete';
                this.member = family;

                setTimeout(() => {
                    this.$bvModal.show('client_family');
                }, 1);
            },

            getSummary() {
                if (this.$route.name !== 'client.show') {
                    this.$router.push({name: 'client.show'});
                }
            },

            resetOtherModal() {
                this.comment_edit = false;
                this.modalMode = '';
            },
        },
    }
</script>

<style scoped>

</style>
